
const FirebaseChangeTypes = {
    ADDED: 'added',
    MODIFIED: 'modified',
    REMOVED: 'removed',
};

export default FirebaseChangeTypes;